// extracted by mini-css-extract-plugin
export var resourcesContainer = "Resources-module--resources-container--1PNL0";